import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, CardTitle } from 'reactstrap';
import { toast } from 'react-toastify';
import { LiaAngleDoubleUpSolid } from 'react-icons/lia';
import '../styles/floatingForm.css'
import gsap from 'gsap';

const UpdateVendorInPage = ({setShowUpdateVendor, containerUpdateRef, id}) => {
  const [name, setName] = useState('');
  const [dname, setDname] = useState('');
  const [emailId, setEmailId] = useState('');
  const [demailId, setDemailId] = useState('');
  const [address, setAddress] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [dmobileNo, setDmobileNo] = useState('');
  const [gstin, setGstin] = useState('');
  const [pan, setPan] = useState('');
  const [year, setYear] = useState('');
  const [about, setAbout] = useState('');
  const [created_date, setCreated_date] = useState('');
  const [logoImageFile, setLogoImageFile] = useState(null);
  const [bannerImageFile, setBannerImageFile] = useState(null);
  const [existingLogoImage, setExistingLogoImage] = useState('');
  const [existingBannerImage, setExistingBannerImage] = useState('');
  const [open, setOpen] = useState('1');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchVendor();
  }, [id]);

  // console.log(id)
  const fetchVendor = async () => {
      if (!id) return;
      try {
        const response = await api.get(`/vendor/get/${id}`);
        const vendor = response.data?.data;
        setName(vendor.name);
        setDname(vendor.comp_directer)
        setEmailId(vendor.emailid);
        setDemailId(vendor.comp_directer_emailid);
        setMobileNo(vendor.mobileno);
        setDmobileNo(vendor.comp_directer_mobile)
        setGstin(vendor.gstin);
        setPan(vendor.comp_pan_no)
        setAddress(vendor.address);
        setYear(vendor.year);
        setAbout(vendor.about);
        setCreated_date(vendor.created_date)
        setExistingLogoImage(vendor.logo_image_path);
        setExistingBannerImage(vendor.banner_image_path);
      } catch (error) {
        console.error('Error fetching vendor:', error);
        alert('Failed to fetch vendor data');
      }
    };

  const validateImageDimensions = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        if (image.width <= maxWidth && image.height <= maxHeight) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      image.onerror = () => {
        reject(new Error('Invalid image file.'))
      };
      image.src = URL.createObjectURL(file);
    });
  };

      const handleReadOnly = (fieldName, message) => (e) => {
      e.preventDefault();
      toast.info(message); // nicer than alert
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!name.trim()) errors.name = 'Name cannot be empty';

    if (!dname.trim()) errors.dname = 'Director/Owner Name cannot be empty';

    if (!emailId.trim()) { errors.emailId = 'email cannnot be empty' } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(emailId)) {
        errors.emailId = 'Please enter a valid email address';
      }
    };

    if (!demailId.trim()) { errors.demailId = 'Director/Owner email cannnot be empty' } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(emailId)) {
        errors.emailId = 'Please enter a valid email address';
      }
    };

    if (!mobileNo.trim()) { errors.mobileNo = 'mobile cannot be empty' } else {
      if (!/^[0-9]{10}$/.test(mobileNo)) {
        errors.mobileNo = 'Mobile number must be exactly 10 digits';
      }
    }

    if (!dmobileNo.trim()) { errors.dmobileNo = 'mobile cannot be empty' } else {
      if (!/^[0-9]{10}$/.test(dmobileNo)) {
        errors.dmobileNo = 'Director/Owner Mobile number must be exactly 10 digits';
      }
    }

    if (!address.trim()) errors.address = 'address cannot be empty'
    if (!gstin.trim()) errors.gstin = 'gst_no cannot be empty'
    if (!pan.trim()) errors.pan = 'pan cannot be empty'
    if (!year) errors.year = 'year cannot be empty'
    if (!about.trim()) errors.about = 'about cannot be empty'

    const allowedImageTypes = ['image/png', 'image/jpeg'];

    if (logoImageFile) {
      if (!allowedImageTypes.includes(logoImageFile.type)) {
        errors.logoImageFile = 'Only PNG and JPG files are allowed'
      } else {
        // const isValidImage = await validateImageDimensions(logoImageFile, 186, 98);
        // if (!isValidImage) {
        //   errors.logoImageFile = 'Package Image must be under 251px by 168px';
        // }
      }
    }

    if (bannerImageFile) {
      if (!allowedImageTypes.includes(bannerImageFile.type)) {
        errors.bannerImageFile = 'Only PNG and JPG files are allowed'
      } else {
        const isValidImage = await validateImageDimensions(bannerImageFile, 1342, 401);
        if (!isValidImage) {
          errors.bannerImageFile = 'banner image must be under 251px by 168px';
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setErrors({});

    const formData = new FormData();
    formData.append('name', name);
    formData.append('comp_directer', dname);
    formData.append('address', address);
    formData.append('email_id', emailId);
    formData.append('comp_directer_emailid', demailId);
    formData.append('mobileno', mobileNo);
    formData.append('comp_directer_mobil', dmobileNo);
    formData.append('emailid', emailId);
    formData.append('mobile_no', mobileNo);
    formData.append('gstin', gstin);
    formData.append('year', year);
    formData.append('created_date', created_date);
    formData.append('about', about);
    formData.append('comp_pan_no', pan)
    formData.append('comp_directer_mobile',dmobileNo)
    

    if (logoImageFile) {
      formData.append('logo_image_path', logoImageFile);
    }
    if (bannerImageFile) {
      formData.append('banner_image_path', bannerImageFile);
    }

    try {
      const response = await api.post(`/vendor/update/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status === "success") {
          toast.success(`Service Providerr updated successfully! ID: ${id}`);
          handleCancel();
      } else {
        toast.error('Failed to update Service Provider');
      }
    } catch (error) {
      console.error('Error updating Service Provider:', error);
      toast.error('Error updating Service Provider');
    }
  };

  const handleCancel = () => {
      setShowUpdateVendor(false);
  };

  const toggle = (id) => {
    if (open === id) {
      setOpen("0");
    } else {
      setOpen(id);
    }

  };

  return (
    <div className='floating-form-container' ref={containerUpdateRef} >
      <div className="heading">
        <h2>Update Tour Operator Details</h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                {/* basic info */}
                <div className="section-1">
                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="name">Service Provider Name </label>
                        <input type="text" id="name" name="name" 
                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                            value={name} onChange={(e) => setName(e.target.value)}
                        placeholder="Enter your full name" />
                        <b>{errors.name && <span className='text-danger small'>{errors.name}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="email">Service Provider Email ID</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={emailId}
                            readOnly
                            className={`form-control ${errors.emailId ? 'is-invalid' : ''}`}
                            placeholder="Enter your email address"
                            onKeyDown={handleReadOnly("emailId", "Email cannot be edited")}
                            onPaste={handleReadOnly("emailId", "Email cannot be edited")}
                            onMouseDown={handleReadOnly("emailId", "Email cannot be edited")}
                            onContextMenu={handleReadOnly("emailId", "Email cannot be edited")}
                        />
                        <b>{errors.emailId && <span className='text-danger small'>{errors.emailId}</span>}</b>
                    </div>


                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="mobile">Service Provider Mobile No</label>
                        <input
                            type="tel"
                            id="mobile"
                            name="mobile"
                            value={mobileNo}
                            readOnly
                            className={`form-control ${errors.mobileNo ? 'is-invalid' : ''}`}
                            onKeyDown={handleReadOnly("mobileNo", "Mobile number cannot be edited")}
                            onPaste={handleReadOnly("mobileNo", "Mobile number cannot be edited")}
                            onMouseDown={handleReadOnly("mobileNo", "Mobile number cannot be edited")}
                            onContextMenu={handleReadOnly("mobileNo", "Mobile number cannot be edited")}
                          />
                    </div>

                          {/* GSTIN */}
                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="gstin">GSTIN</label>
                        <input
                            type="text"
                            id="gstin"
                            name="gstin"
                            value={gstin}
                            readOnly
                            className={`form-control ${errors.gstin ? 'is-invalid' : ''}`}
                            placeholder="Enter your GSTIN"
                            onKeyDown={handleReadOnly("gstin", "GSTIN cannot be edited")}
                            onPaste={handleReadOnly("gstin", "GSTIN cannot be edited")}
                            onMouseDown={handleReadOnly("gstin", "GSTIN cannot be edited")}
                            onContextMenu={handleReadOnly("gstin", "GSTIN cannot be edited")}
                        />
                        <b>{errors.gstin && <span className='text-danger small'>{errors.gstin}</span>}</b>
                    </div>

                    {/* PAN */}
                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="pan">Company PAN</label>
                        <input
                          type="text"
                          id="pan"
                          name="pan"
                          value={pan} // must be populated from state
                          // readOnly
                          className={`form-control ${errors.pan ? 'is-invalid' : ''}`}
                          onKeyDown={handleReadOnly("pan", "PAN cannot be edited")}
                          onPaste={handleReadOnly("pan", "PAN cannot be edited")}
                          onMouseDown={handleReadOnly("pan", "PAN cannot be edited")}
                          onContextMenu={handleReadOnly("pan", "PAN cannot be edited")}
                      />
                        <b>{errors.pan && <span className='text-danger small'>{errors.pan}</span>}</b>
                    </div>

                </div>
                  
                <hr className='form-rule' />

                  {/* company director info */}
                <div className="section-1">

                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="name">Director/Owner Name</label>
                        <input type="text" id="dname" name="dname" 
                            className={`form-control ${errors.dname ? 'is-invalid' : ''}`}
                            value={dname} onChange={(e) => setDname(e.target.value)}
                        placeholder="Enter your full name" />
                        <b>{errors.dname && <span className='text-danger small'>{errors.dname}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="email">Director/Owner Email</label>
                        <input type="demail" id="demail" name="demail" 
                        className={`form-control ${errors.emailId ? 'is-invalid' : ''}`} value={demailId} onChange={(e) => setDemailId(e.target.value)} placeholder="Enter your email address" />
                        <b>{errors.demailId && <span className='text-danger small'>{errors.demailId}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="mobile">Director/Owner Mobile No.</label>
                        <input type="tel" id="dmobile" name="dmobile" maxLength="10" value={dmobileNo}
                        className={`form-control ${errors.dmobileNo ? 'is-invalid' : ''}`}
                        onChange={(e) => setDmobileNo(e.target.value)} placeholder="Enter your mobile number" />
                        <b>{errors.dmobileNo && <span className='text-danger small'>{errors.dmobileNo}</span>}</b>
                    </div>

                </div>

                <div className='section-1'>
                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="yearInBusiness">Year in Business *</label>
                        <input type="number" id="yearInBusiness" name="yearInBusiness" className={`form-control ${errors.year ? 'is-invalid' : ''}`} value={year} onChange={(e) => setYear(e.target.value)} placeholder="e.g. 5 years" />
                        <b>{errors.year && <span className='text-danger small'>{errors.year}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label htmlFor="address">Address *</label>
                        <input type="text" id="address" className={`form-control ${errors.address ? 'is-invalid' : ''}`} value={address} onChange={(e) => setAddress(e.target.value)} name="address" placeholder="Enter Address" />
                        <b>{errors.address && <span className='text-danger small'>{errors.address}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-30">
                      <label htmlFor="address">Created Date</label>
                      <input
                        type="text"
                        value={created_date}
                      />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label htmlFor="aboutUs">About Us *</label>
                        
                        <ReactQuill value={about} onChange={setAbout} className={`react-quill ${errors.about ? 'is-invalid' : ''}`} placeholder="Enter Description" />
                        <b>{errors.about && <span className='text-danger small'>{errors.about}</span>}</b>
                    </div>
                </div>

                <div className="section-1">

                    <h2 className='wid-100'>Upload Image</h2>

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="logo">Choose Logo Image * <br /> (only png and Jpg size 1342px*401px)</label>
                        
                        <div class="file-select">
                            <div class="file-select-button" id="fileName">Choose File</div>
                            <div class="file-select-name" id="noFile">{logoImageFile?.name || "No file chosen..."}</div> 
                            <input type="file" id="logo" onChange={(e) => setLogoImageFile(e.target.files[0])} />
                        </div>
                            <b>{errors.logoImageFile && <span className="text-danger small">{errors.logoImageFile}</span>}</b>
                            <div className='mt-2'>
                        {existingLogoImage && !logoImageFile && (
                          <img style={{ maxWidth: '100px', maxHeight: '100px' }} src={`${process.env.REACT_APP_IMAGE_BASE_URL}${existingLogoImage}`} alt="Logo" />
                        )}
                      </div>

                    </div>
                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="banner">Choose Banner Image * <br /> (only png and Jpg size 186px*98px)</label>
                        
                        <div class="file-select">
                            <div class="file-select-button" >Choose File</div>
                            <div class="file-select-name" >{bannerImageFile?.name || "No file chosen..."}</div> 
                            <input type="file" id="banner" onChange={(e) => setBannerImageFile(e.target.files[0])} />
                        </div>
                            <b>{errors.bannerFile && <span className='text-danger small'>{errors.bannerFile}</span>}</b>
                            {existingBannerImage && !bannerImageFile && (
                          <img style={{ maxWidth: '100px', maxHeight: '100px' }} src={`${process.env.REACT_APP_IMAGE_BASE_URL}${existingBannerImage}`} alt="Banner" />
                        )}

                    </div>
                </div>

            <div className="form-btn-container">

                <button type='submit'>Update</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>

            </div>

            </div>




        </form>

    </div>
  );
};

export default UpdateVendorInPage;
